import React from 'react';
import styles from './Checkbox.module.scss';
import { Check } from 'lucide-react';

interface CheckboxProps {
  label: string;
  checked: boolean;
  onChange: () => void;
  className?: string;
}

const Checkbox: React.FC<CheckboxProps> = ({ label, checked, onChange, className }) => {
  return (
    <label className={`${styles.container} ${className}`}>
      <div className={styles.checkboxWrapper}>
        <input
          type="checkbox"
          checked={checked}
          onChange={onChange}
          className={styles.input}
        />
        <div className={`${styles.checkbox} ${checked ? styles.checked : ''}`}>
          {checked && <Check size={14} />}
        </div>
      </div>
      <span className={styles.label}>{label}</span>
    </label>
  );
};

export default Checkbox; 